module.exports = __webpack_public_path__ + "img/proList1_05.107bc2cd.jpg";